import { render, staticRenderFns } from "./projects-select.renderer.vue?vue&type=template&id=2171d928&scoped=true&"
import script from "./projects-select.renderer.vue?vue&type=script&lang=js&"
export * from "./projects-select.renderer.vue?vue&type=script&lang=js&"
import style0 from "./projects-select.renderer.vue?vue&type=style&index=0&id=2171d928&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2171d928",
  null
  
)

export default component.exports